module.exports = __webpack_public_path__ + "static/media/sku219400843.846fb7b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/sku219400843.png
// module id = 536
// module chunks = 0